<template>
  <div class="writeProcedureBox">
    <div class="procedureMain">
      <div class="procedureHead ft16">
        <!-- <ul v-if="fromType!=3">
          <li></li>
          <router-link to="/personal/serviceHome" tag="li">我的公证&nbsp;&gt;&nbsp;</router-link>
          <router-link to="/personal/serviceHome?flag=third" tag="li">赋强公证&nbsp;&gt;&nbsp;</router-link>
          <li>公证进度</li>
        </ul> -->
<!--        <ul v-if="fromType==2">-->
<!--          <li @click="goDataList">{{(notaryBusinessId == 2 || notaryBusinessId == 7) ? '贷款赋强公证' : '调解赋强公证'}} - 公证进度</li>-->

<!--        </ul>-->
        <div class="content-top clearfix">
          当前位置：
          <span @click="goDataList">
            {{(notaryBusinessId == 2 || notaryBusinessId == 3) ? '贷款赋强公证' : '调解赋强公证'}} - 公证进度
          </span>
        </div>
      </div>
      <Progress v-if="fromType==1"></Progress>
      <Progressfq v-if="fromType==2"></Progressfq>
      <ProgressExecution v-if="fromType==4"></ProgressExecution>
      <!-- <personal-service v-if="isType"></personal-service>
      <enterprise-service v-if="!isType"></enterprise-service> -->
    </div>
  </div>
</template>
<script>
import BaseApi from "@lib/baseApi.js";
// import personalService from "./writeProcedure/personalService.vue";
// import enterpriseService from "./writeProcedure/enterpriseService.vue";
import Progress from "./writeProcedure/Progress.vue";
import Progressfq from "./writeProcedure/Progressfq.vue";
import ProgressExecution from "./writeProcedure/ProgressExecution.vue";
import {mapState, mapGetters} from "vuex";
export default {
  data() {
    return {
      isType: true,
      fromType:1,//1-一般公证，2-赋强公证，3-申请强执，4.贷款赋强
      notaryBusinessId: ''
    };
  },
  computed:{
      ...mapState(['currentInfo','userInfo','curState']),
  },
  mounted() {
    this.notaryBusinessId = this.$route.query.notaryBusinessId;
    BaseApi.createRpcToken("/user/v2/getUserInfo")
      .then(data => {
          let userArr=[...[data.datas.person],...data.datas.enterpriseList];
          let curInfo=userArr.filter(item=>item.userId==data.datas.currentUserId)[0];
        if (curInfo.realNameType == 1) {
          this.isType = true;
        } else {
          this.isType = false;
        }
      })
      .catch(function(e) {
        errorLog(e);
      });
  },
  created(){
    //公证来源
    if(this.$route.query.fromType){
      this.fromType=this.$route.query.fromType;
    }
  },
  components: {
    // personalService,
    // enterpriseService,
    Progress,
    Progressfq,
    ProgressExecution
  },
  watch:{
    "curState"(data){
      this.$router.replace("/personal/serviceHome")
    }
  },
  methods: {
    goDataList() {
      if(this.$route.query.fromType==4){ // 强执公证
        if (this.notaryBusinessId == 3 ) {
          this.$router.push("/personal/service/loan?flag=execution");
        } else if (this.notaryBusinessId == 8) {
          this.$router.push("/personal/service/conciliation?flag=execution");
        }
      }else{
        if (this.notaryBusinessId == 2 ) {
          this.$router.push("/personal/service/loan?flag=third");
        } else if (this.notaryBusinessId == 7) {
          this.$router.push("/personal/service/conciliation?flag=third");
        }
      }
    },
  }

};
</script>

<style lang="scss">
@import "@assets/scss/base.scss";
.writeProcedureBox {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  .procedureMain {
    padding: 20px;
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    box-sizing: border-box;
    .procedureHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      .content-top {
        height: 52px;
        background: url(../../../../assets/images/judicial/pos.png) no-repeat;
        font-size: 16px;
        background-size: 3px 16px;
        background-position: 0 3px;
        box-sizing: border-box;
        padding-left: 13px;

        span {
          cursor: pointer;
          color: $reminder-text;
        }
      }
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2),
      li:nth-child(3) {
        color: #787878;
        font-family: "PingFangSC-Medium";
        cursor: pointer;
      }
      li:last-child {
        color: #e88078;
      }
    }
    .procedureCon {
      margin-top: 20px;
      .flowChart {
        width: 100%;
        padding-top: 40px;
        padding-bottom: 43px;
        overflow: hidden;
        height: 50px;
        li {
          float: left;
          height: 20px;
        }
        li:nth-child(2n-1) {
          position: relative;
          width: calc((100% - 112px) / 8);
          span {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -1px;
            display: inline-block;
            width: 100%;
            height: 2px;
            background: #fbeceb;
            border-radius: 3px;
          }
        }
        dl.active {
          li:nth-child(2n-1) {
            span {
              background: #e98880;
            }
          }
          li:nth-child(2) {
            cursor: pointer;
            div {
              width: 20px;
              height: 20px;
              background: #fbeceb;
              border: 1px solid #e88078;
              border-radius: 50%;
              padding: 4px;
              box-sizing: border-box;
              margin: 0 4px;
            }
            span {
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #e88078;
            }
          }
        }
        li:nth-child(2n) {
          position: relative;
          div {
            width: 20px;
            height: 20px;
            background: #fbeceb;
            border: 1px solid #fbeceb;
            border-radius: 50%;
            padding: 2px;
            box-sizing: border-box;
            margin: 0 4px;
          }
          p {
            position: absolute;
            width: 84px;
            color: #505050;
            top: 31px;
            left: -26px;
            text-align: center;
          }
        }
        .select {
          span {
            background: #e98880 !important;
          }
        }
      }
    }
    .procedureTab {
      width: 100%;
      display: table;
      .putIn {
        text-align: center;
        span {
          display: inline-block;
          border: 1px solid #e29999;
          width: 140px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 12px;
          color: #e29999;
        }
      }
      .message {
        display: none;
        h5 {
          background: #f7f7f7;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          padding-left: 20px;
          color: #646464;
          font-weight: normal;
          border-bottom: 1px solid #e4e8eb;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
        }
        .messageLeft {
          width: calc(96% / 2);
          display: table;
          border: 1px solid #e4e8eb;
          margin-bottom: 20px;
          .messageCon {
            width: 100%;
            box-sizing: border-box;
            height: 407px;
            background: #fafafa;
            position: relative;
            .el-form {
              padding-left: 43px;
              padding-top: 25px;
              .el-form-item.is-required:not(.is-no-asterisk)
                > .el-form-item__label:before {
                content: "";
              }
              .el-form-item {
                font-size: 12px;
                color: #646464;
                .el-form-item__label {
                  line-height: 24px;
                  padding: 0;
                  width: 150px;
                  text-align: left;
                }
                .el-form-item__content {
                  line-height: 24px;
                }
              }
              .el-form-item__content {
                position: relative;
                .el-input {
                  width: 296px;
                  .el-input__inner {
                    padding-left: 10px;
                    height: 28px;
                    line-height: 20px;
                    border-radius: 0;
                  }
                }
                .el-form-item__error {
                  left: 152px;
                }
              }
              .subBox {
                position: absolute;
                bottom: -30%;
                left: -100px;
                .el-button {
                  width: 140px;
                  line-height: 36px;
                  padding: 0;
                  background-color: #fff;
                  font-size: 12px;
                  color: #e29999;
                  border-color: #e29999;
                }
              }
              .el-button:hover {
                color: #fff;
                background-color: #a5303d;
                border-color: #a5303d;
              }
            }
            .numFile {
              position: relative;
              p {
                position: absolute;
                left: 150px;
                color: #f56c6c;
                font-size: 12px;
              }
            }
            .fileNum {
              background: #f0f0f0;
              height: 20px;
              width: 60px;
              border-radius: 2px;
              font-size: 12px;
              color: #646464;
              position: relative;
              .el-input__inner {
                padding: 0;
                height: 20px;
                line-height: 20px;
                padding-left: 10px;
                box-sizing: border-box;
              }
            }
          }
        }
        .messageLeft:nth-child(1) {
          margin-right: 3%;
        }
        .messageStatus {
          width: 100%;
          border: 1px solid #e4e8eb;
          .messageCon {
            display: flex;
            width: 100%;
            box-sizing: border-box;
            height: 240px;
            background: #fafafa;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-size: 14px;
            color: #646464;
            img {
              margin-bottom: 10px;
            }
            p {
              width: 60%;
              text-align: center;
            }
          }
        }
        .moneyBox {
          border: 1px solid #e4e8eb;
          .messageCon {
            background: #fafafa;
            width: 100%;
            height: 161px;
            padding: 20px 11px;
            box-sizing: border-box;
            table {
              table-layout: auto;
              thead {
                width: 100%;
              }
              th:nth-child(1),
              td:nth-child(1) {
                width: "24.4%";
              }
              th:nth-child(2),
              td:nth-child(2) {
                width: "16.2%";
              }
              th:nth-child(3),
              td:nth-child(3) {
                width: "19.8%";
              }
              th:nth-child(4),
              td:nth-child(4) {
                width: "14.4%";
              }
              th:nth-child(5),
              td:nth-child(5) {
                width: "16.2%";
              }
              th:nth-child(6),
              td:nth-child(6) {
                width: "9";
              }
              th {
                background: #f9f9f9;
              }
              td {
                background-color: #fff;
              }
              th,
              td {
                padding: 0;
                vertical-align: middle;
                width: 100px;
                overflow: hidden;
                .cell {
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                }
              }
            }
            p {
              text-align: right;
              font-size: 12px;
              color: #969696;
              margin-top: 28px;
              span {
                font-size: 24px;
                color: #e88078;
              }
            }
          }
        }
      }
      .active {
        display: block;
      }
    }
  }
}
</style>

